module.exports = __webpack_public_path__ + "img/consultant.931f9a22.png";